<template>
  <transition-group name="zoom" tag="div" class="position-r full-height-width">
    <div key="croper" v-show="selectedImage !== null && this.selectedImageExtension.toLowerCase() !== 'gif' " class="position-a full-height-width">
      <cropper
        v-if="selectedImage !== null"
        :img-src="selectedImage"
        :extension="selectedImageExtension"
        ref="cropper">
      </cropper>
    </div>
     <div key="selector" v-show="selectedImage !== null && this.selectedImageExtension.toLowerCase() === 'gif' " class="position-a full-height-width">
        <div class="image-gallery-prev-control">
          <div class="gifimage"
          :style="{ backgroundImage: 'url(' + selectedImage + ')'}">
          </div>
        </div>
    </div>
    <el-row key="selector" v-show="selectedImage === null" type="flex" align="middle" class="position-a full-height-width">
      <el-col>
        <el-upload drag
          class="popup_upload"
          accept="image/*"
          action=""
          :multiple="false"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="handlePreview">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text" v-html="resource.imagegalleryuploadertext"></div>
          <div class="el-upload__tip" slot="tip">{{resource.imagegalleryuploadertip}}</div>
        </el-upload>
      </el-col>      
    </el-row>
  </transition-group>
</template>
<script>
import {
  mapGetters
} from 'vuex'
import config from '@/config'
import Cropper from '../Cropper'
import { getExtension } from '@/modules/helper'

export default {
  props: {
    showSave: {
      type: Boolean
    },
    showBack: {
      type: Boolean
    },
    eventBus: {
      type: Object
    }
  },
  data () {
    return {
      selectedImage: null,
      selectedImageExtension: '',
      outputImage: null
    }
  },
  computed: {
    ...mapGetters([
      'resource'
    ])
  },
  created () {
    this.eventBus.$on('backClick', this.handleBackClick)
    this.eventBus.$on('saveImage', this.handleSaveImageClick)
  },
  beforeDestroy () {
    this.eventBus.$off('backClick', this.handleBackClick)
    this.eventBus.$off('saveImage', this.handleSaveImageClick)
  },
  methods: {
    handleSaveImageClick () {
      const result = this.$refs.cropper.getResult()
      if (this.selectedImageExtension.toLowerCase() === 'gif') {
        result.image = this.selectedImage
      }
      this.eventBus.$emit('image-selected', result)
      this.selectedImage = null
      this.selectedImageExtension = ''
    },
    handlePreview (file) {
      var reader = new FileReader()
      this.selectedImageExtension = getExtension(file.name)
      if (!['jpeg', 'png', 'jpg', 'gif'].includes(this.selectedImageExtension.toLowerCase())) {
        this.$notify.error({
          ...config.notificationDefaultOptions,
          message: this.resource.imagegalleryuploadertip
        })
        return
      }
      reader.onload = (e) => {
        this.selectedImage = e.target.result
        this.$emit('update:showBack', true)
        this.$emit('update:showSave', true)
      }
      reader.readAsDataURL(file.raw)
    },
    handleBackClick () {
      this.selectedImage = null
      this.$emit('update:showBack', false)
      this.$emit('update:showSave', false)
    }
  },
  components: {
    Cropper
  }
}
</script>
<style>
@keyframes zoomOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: scale3d(.3, .3, .3);
  }
  to {
    opacity: 0;
  }
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale3d(.3, .3, .3);
  }
  50% {
    opacity: 1;
  }
}

.zoom-enter-active {
  animation: zoomIn 1.5s;
}

.zoom-leave-active {
  animation: zoomOut 1.5s;
}
.gifimage{
  height: 400px;
  width: 400px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  margin: 0 19%;
}
</style>



// WEBPACK FOOTER //
// src/components/Shared/ImageGallery/CustomImageUploader.vue